import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
	state: {
		noticias : '',
		videos : {
			recetas : [],
			recetasen : [],
			tasting : [],
		}
	},
	getters: {
		getNoticias : state => {

			let noticias = {
				es : [],
				en : []
			};

			if(!!state.noticias){

				noticias.es = state.noticias.filter(e => e.language[0] == 21).slice(0,6);
				noticias.en = state.noticias.filter(e => e.language[0] == 24).slice(0,6);
				return noticias;
			}

		},
		getFakeNew : state => {

			let urls = ['aceite-oliva-girasol-diferencias', 'enoturismo-en-navidad', 'la-monda-de-la-rosa-del-azafran', 'alimentos-mejoran-estadodeanimo'];

			let noticias = {
				es : [],
				en : []
			};

			if(!!state.noticias){


				noticias.es = state.noticias.filter(e => {
					
					if(!e.content.rendered.includes('lang="EN')){
							return true;
					}

				}).slice(0,6);
				console.log(noticias.es);
				noticias.en = state.noticias.filter(e => e.content.rendered.includes('lang="EN')).slice(0,6);
				return noticias;
			}
		},
		getVideosRecetas : state => state.videos.recetas,
		getVideosRecetasEN : state => state.videos.recetasen,
		getVideosTasting : state => state.videos.tasting
	},
	actions: {
		requestNoticias : ({commit},) => {
			return new Promise((resolve, reject) => {

				axios.get(`https://blog.aldonzagourmet.com/wp-json/wp/v2/posts?_embed&per_page=30`)
				.then(response => {
					commit('setNoticias', response.data);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestVideos : ({commit}) =>{
			axios.get('https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyA_l78FldVWxqLuosRXYry3fgISeR65xPo&playlistId=PLylP3JVVyRmIqp6FDarVEEOePn3uDzlDe&part=snippet&order=date&maxResults=50')
			.then( r => {
				commit('setVideosRecetas', r.data)
			})

			axios.get('https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyA_l78FldVWxqLuosRXYry3fgISeR65xPo&playlistId=PLylP3JVVyRmJ-_0OgyFXPtxAaIhB0z5Tj&part=snippet&order=date&maxResults=50')
			.then( r => {
				commit('setVideosRecetasEN', r.data)
			})

			axios.get('https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyA_l78FldVWxqLuosRXYry3fgISeR65xPo&playlistId=PLylP3JVVyRmLErVc6E2ivXql2ljiMBLI0&part=snippet&order=date&maxResults=50')
			.then( r => {
				commit('setVideosTasting', r.data)
			})
		}
	},
	mutations: {
		setNoticias : (state, noticias) => {
			state.noticias = noticias;
		},
		setVideosRecetas : (state, videos) => {
			state.videos.recetas = videos.items;
		},
		setVideosRecetasEN : (state, videos) => {
			state.videos.recetasen = videos.items;
		},
		setVideosTasting : (state, videos) => {
			state.videos.tasting = videos.items;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js